import * as React from 'react';

import type { MultiTagOptionProps } from 'af-fields/MultiTagSelect';

import Tag from 'af-components/Controls/Tag';

import type FormModel from './formModel';

type Props = MultiTagOptionProps<FormModel['itemCategories'][0]>;

const ItemCategoryOption = (props: Props) => {
	const { data, innerProps, getStyles } = props;

	const styles = getStyles('option', props);
	const mergedStyle = Array.isArray(styles)
		? styles.reduce<React.CSSProperties>((acc, style) => ({ ...acc, ...style }), {})
		: (styles as React.CSSProperties);

	return (
		<div style={mergedStyle} {...innerProps}>
			<Tag size="small" transparent>
				<span>{data.name}</span>
			</Tag>
		</div>
	);
};

export default React.memo(ItemCategoryOption);
